import { parseContentRegistry } from "@/content/registry-core";
import { LEVELS_BY_DOMAIN } from "./levels-by-domain";

export { LEVELS_BY_DOMAIN } from "./levels-by-domain";

export const LEVEL_REGISTRY = parseContentRegistry(LEVELS_BY_DOMAIN);
